import { useEffect, useRef, useState } from 'react'

const ASYNC_WAIT = 700

export const useCompanySettingsRankingFormControl = <T,>(initialValue: T, callback: (T) => void): [T, (value: T) => void] => {
  const timer = useRef(0)
  const [formValue, setFormValue] = useState<T>(initialValue)

  const handleChange = (currentValue) => {
    setFormValue(currentValue)

    if (!!timer.current) {
      clearTimeout(timer.current)
    }

    timer.current = window.setTimeout(() => {
      if (currentValue !== initialValue) {
        callback(currentValue)
      }
    }, ASYNC_WAIT)
  }

  useEffect(() => {
    return () => {
      clearTimeout(timer.current)
    }
  }, [])

  return [formValue, handleChange]
}
